import actionTypes from "../actions/action-types";
import isEqual from "lodash-es/isEqual";
import {set,get} from "../utils/dotutils";

const SelectorGridReducer = (state = {}, action) => {
    try {
        switch (action.type) {
            case actionTypes.SET_SELECTORGRID_STATE:
                const newState = JSON.parse(JSON.stringify(state, function(key, value) {
                    if (key === "filterElement") {
                        return;
                    }
                    return value;
                }));
                set(newState, action.selectorgrid, {...get(newState, action.selectorgrid), ...action.state});
                return newState;
            default:
                return state;
        }
    } catch (e) {
        console.error(e);
        return state;
    }
};

export default SelectorGridReducer;